"use client";

import { FlightTabs } from "@/feature/flight/search/components/results/flight-tabs";
import { filterFlightResult } from "@/feature/flight/search/lib/filtering/filter-results";
import useFlightSearchSSE from "@/feature/flight/search/hooks/use-flight-search-sse";
import { IDecodedFlightSearch } from "@/feature/flight/search/types/search";

import { useAppSelector } from "@/redux/hooks";
import { useMemo } from "react";
import FlightSearchSidebar from "../filters/flight-search-sidebar";

type FlightSearchProps = {
  decoded: IDecodedFlightSearch;
};

export default function FlightSearch({ decoded }: FlightSearchProps) {
  const selectOption = useAppSelector(
    (state) => state.extractFlightFilter.selectOption,
  );

  const cachedFlights = useAppSelector(
    (state) => state.extractFlightFilter.cachedFlights,
  );

  //! this is  hook for fight search
  const { flightData, isCacheHit } = useFlightSearchSSE({
    formData: decoded,
  });

  //! Use cached data only on cache hit, otherwise use live SSE data
  const flights = isCacheHit ? cachedFlights : flightData;

  //! extract flight data based flight search
  const result = useMemo(
    () => filterFlightResult(flights, selectOption) ?? [],
    [flights, selectOption],
  );

  return (
    <section className="container-wrapper">
      <div className="container px-0 relative flex w-full flex-1 flex-col lg:flex-row lg:items-start">
        {/* filter section  */}
        <FlightSearchSidebar total={result.length} />

        <div className="overflow-hidden flex-1">
          <FlightTabs flights={result} />
        </div>
      </div>
    </section>
  );
}
